import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import '@fontsource-variable/inter'
import '@fontsource-variable/sora'
import './index.css'
import App from './App.jsx'
import { EstimateProvider } from './context/EstimateContext.jsx'
import { initIframeAutoResize } from './lib/embed.js'

// The internal ops dashboard is lazy-loaded so the public estimate bundle
// (embedded on the WordPress site) stays lean.
const OpsApp = lazy(() => import('./ops/OpsApp.jsx'))

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/ops/*"
          element={
            <Suspense fallback={<div className="p-8 text-sm text-muted">Loading…</div>}>
              <OpsApp />
            </Suspense>
          }
        />
        {/* Public estimate tool at everything else. */}
        <Route
          path="*"
          element={
            <EstimateProvider>
              <App />
            </EstimateProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)

// When embedded in an <iframe> on the WordPress site, report height to the parent.
initIframeAutoResize()
